module.exports = __webpack_public_path__ + "img/cert_icon.74076bda.svg";